import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import Oluwaseun from "../../../assets/judges/oluwaseun.jpg";
import tafida from "../../../assets/judges/tafida.JPG";
import Joseph from "../../../assets/judges/joseph.jpg";
import Odeh from "../../../assets/judges/odeh.png";
import Uwaje from "../../../assets/judges/uwaje.jpg";

const ourJudges = [
  {
    name: "Oluwaseun Ayodeji Osowobi",
    title: "Executive Director, Stand to End Rape",
    profile:
      " Oluwaseun Ayodeji Osowobi is a multi-award-winning global gender equality advocate with experience in deploying solutions to challenge social barriers that promote sexual and gender-based violence against women and girls and utilising social and behaviour change communication to improve attitudes and practices to foster gender equality. She collaborates with and scales the capacity of state and non-state actors to implement policies and programs that advance women’s rights and safety.",
    profile2:
      "Oluwaseun is the Executive Director of Stand to End Rape Initiative (STER), 2020 Global Citizen Nigeria Hero, a UN Young Leader for the Sustainable Development Goals (SDGs), and TIME 100 NEXT Honouree.",
    imgpath: Oluwaseun,
  },
  {
    name: "Mal. Saied Tafida (Phd)",
    title: "National Coordinator Public Financing for SDGs, UNDP",
    profile:
      "Saied leads the development of SDG Financing Frameworks to leverage public finance and other fiscal policies to achieve Sustainable Development Goals. with the United Nations Development Program. He engages government policymakers and supports research and capacity development, particularly in Africa, to develop fiscal policies to achieve specific SDGs. He facilitates meetings and partnerships to support governments and policy drivers to build consensus and support for SDG-related financing policies.",
    profile2:
      "He provides technical assistance and facilitates cooperation, including South-South partnerships, to policymakers and other organizations to strengthen capacity, share experiences, and leverage advances in tackling Illicit Financial Flow (IFFs) to build equitable and sustainable national public finance systems. He has been the lead researcher on Political Economy Analysis (PEA), Organizational Capacity Assessment (OCA), and Fiscal Space Analysis (FSA) for USAID, OXFAM, and FCDO in Nigeria and Some Sub-Saharan African Countries on fiscal transparency and public finance management.",
    imgpath: tafida,
  },
  {
    name: "Joseph Amenaghawon",
    title: "Strategy and Growth Advisor, BudgIT Foundation",
    profile:
      "Joseph Idahosa Amenaghawon is the Strategy and Growth Advisor at BudgiT Foundation. In the last twelve years, he served as the Economic Governance/ Justice Coordinator at the Open Society Initiative for West Africa (OSIWA), where he was actively involved in supporting strategy design and implementation, grant making and grantees supervision, project management, monitoring, evaluation and learning.",
    profile2:
      " Joseph is currently a Doctorate candidate in Development Studies at Atlantic International University. He holds a master’s degree in international law and Diplomacy (MILD) and a bachelor’s degree in Economics.  He has also attended several professional and leadership training courses, including the prestigious Harvard Kennedy School.",
    imgpath: Joseph,
  },
  {
    name: "Odeh Friday",
    title: "Country Director, Accountability Lab Nigeria",
    profile:
      "Odeh Friday is a highly accomplished and visionary leader, serving as the Country Director and driving force behind Accountability Lab Nigeria. With a focus on accountability, transparency, and anti-corruption, Odeh has demonstrated exceptional expertise and leadership in these critical areas. With over 11 years of experience in the development and humanitarian sectors, Odeh has made a significant impact through his work with reputable organizations such as Save the Children International and the Association of Positive Youth Living with HIV/AIDS. His extensive background has equipped him with a deep understanding of the challenges of promoting good governance. Under Ode’s guidance, Accountability Lab Nigeria has reshaped governance programming within the country, assembling a dynamic team of over 36 staff members &amp; dedicated volunteers. His exceptional leadership skills have also been instrumental in securing substantial funding of nearly $2 million from esteemed donors, including Voice - OXFAM, Luminate, MacArthur, and the Ford Foundation.",
    profile2:
      " Odeh’s commitment to continuous growth and learning is evident in his active pursuit of opportunities to expand his knowledge and exposure. He is an alumnus of the esteemed Transparency International School of Integrity 2018, where he underwent rigorous anti-corruption training alongside future leaders. Additionally, he participated in the Dutch Visitors Program 2019, a prestigious initiative organized by the Dutch Government, focused on public and economic diplomacy. Odeh’s visionary approach, unwavering dedication, and remarkable achievements position him as a trailblazer in addressing the challenges facing Nigeria and the broader African region. His commitment to fostering accountability, transparency, and ethical governance serves as a powerful inspiration to others in their pursuit of positive change. With Odeh at the helm, the prospects for a more accountable and transparent future are truly promising.",
    imgpath: Odeh,
  },
  {
    name: "Nkemdilim Begho Uwaje",
    title: "Managing Director/CEO, Future Software Resources Ltd",
    profile:
      "An entrepreneurial and strategically driven executive with experience as a CEO, Founder and Non-Executive Director of private, listed and public sector organisations. Nkemdilim is a seasoned Information Technology professional with over 15 years of cross-sector industry experience in Nigeria, Africa's largest emerging economy. She combines strategic, digital technology and operational experience with a deep understanding of business transformation, change leadership and risk oversight. Currently CEO of Future Software Resources Ltd. (Futuresoft), one of Nigeria's leading digital & technology solutions companies, providing a broad range of solutions for the scaling African enterprise, to consistently attract and retain its target audience, optimise its processes and increase its bottom line. Futuresoft has served over 200 clients across 20 industries and has trained over 1,500 CEOs, executives and board members in Digital.",
    profile2:
      " Nkerndilim has been recognized as an Obama Africa Leader, Forbes's Top Ten Female Tech Founders in Africa, Global Digital Women Top 10 Most Inspiring Women in Africa, Lionesses of Africa’s Top 100 Women and Ventures Africa 42 Most Innovative Africans. She currently serves on various private, public sector and listed company boards including Stanbic IBTC Holdings PLC, Novare Investment Fund Ltd., Lagos State Research & Innovation Council (LASRIC) and The Society for Corporate Governance in Nigeria. Nkem also sits on the advisory boards of The BudgIT Foundation and Global Leaders Today USA. She chairs the Technology and Innovation Committees of Stanbic IBTC Holdings PLC, The Society for Corporate Governance and The BudgIT Foundation. Over the years she has served in the leadership of the NESG Digital Economy Thematic group; and was a member of The Nigerian National IT Software Committee and the Nigerian Electronic Voting Think Tank where she contributed to the advancement of digitalization and shaping policy to support its inclusive delivery.",
    imgpath: Uwaje,
  },
];

const Judges2023 = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#049593",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "rgba(0, 0, 0, 0)",
    borderColor: "3px solid #D7A036",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#004165",
      borderColor: "#004165",
    },
  }));

  return (
    <Grid item xs={12} md={12}>
      <Typography
        variant={"body1"}
        fontWeight={500}
        textAlign={"left"}
        padding={{ xs: "0% 0% 10% 0%", sm: "1% 0%" }}
        color={"#4f4f4f"}
        lineHeight={"1.625em"}
      >
        The Active Citizens Awards are judged by an esteemed panel of civic
        leaders and experts. The judging is a rigorous two-stage process
        including pre-scoring to determine shortlists and a judging meeting
        where entries are discussed and evaluated in detail to decide the
        winning nominations.
      </Typography>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        flexWrap={"wrap"}
        marginTop={"5%"}
      >
        {ourJudges.map((judge, index) => {
          const { name, profile, profile2, imgpath, title } = judge;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
              marginRight={{ xs: "0%", sm: "2%" }}
              marginLeft={{ xs: "4%", sm: "0%" }}
            >
              <Card sx={{ maxWidth: 360, height: "100%" }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="340"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#004165"}
                      component="div"
                      paddingBottom={"4%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body2"
                      color="#D7A036"
                      fontWeight={700}
                      data-aos={"fade-up"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile2}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
      <Box padding={"5% 2% 1% 0%"} display={"flex"} justifyContent={"center"}>
        <ColorButton
          component={"a"}
          variant="contained"
          size="medium"
          href={"/2022-judges"}
          endIcon={
            <ArrowRightAltIcon
              sx={{
                color: "#049593",
                height: "32px",
                width: "32px",
                "&:hover": {
                  color: "#049593",
                },
              }}
            />
          }
        >
          Meet 2022 Judges
        </ColorButton>
      </Box>
    </Grid>
  );
};

export default Judges2023;
